/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration401,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration404,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidResetIntegration.ts";

function getPostApiV1IndividualpaymentParcelsParcelidResetIntegrationUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/reset-integration` as const,
  };
  return res;
}

/**
 * @description Somente parcelas pendentes ou aguardando integração são alteradas. Migrado do legado IndividualPayment/ResetIntegrationParcel. **(Requer Authorization para autenticação)**
 * @summary Limpa a data de integração de uma parcela aberta (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/reset-integration}
 */
export async function postApiV1IndividualpaymentParcelsParcelidResetIntegration(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams["parcelId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration401
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration404
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidResetIntegrationUrl(
      parcelId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
